// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 4736) return "vendor.css";
	if (chunkId === 4296) return "bundle.css";
	// return url for filenames based on template
	return "" + (chunkId === 9404 ? "monaco-editor" : chunkId) + ".css";
};